import { Dropdown, IComboBoxOption, ResponsiveMode } from "@fluentui/react";
import { AreaChartSheet, SheetForm } from "../../../interfaces/CoObject";
import React, { Dispatch, SetStateAction } from "react";
import { formatMessage } from "../../../../utils/helpers/LanguageHelper";
import useDropDownAreaAndChart from "./DropDownAreaAndChartHook";

interface DropDownAreaAndChartProps {
  isEdit?: boolean;
  name: AreaChartSheet;
  sheetsAreaChartMap: Map<string, string[]>;
  sheet: SheetForm;
  selectNameComboBox: (option: IComboBoxOption) => void;
  onRenderAreaCaretDown?: any;
  type: string;
  isFileExcelExisting?: boolean;
  isComponentInstance?: boolean;
  isLocked?: boolean;
  objectSource: string;
  isOldValueForAreaToHide?: boolean;
  hasSheetToBeSelected?: boolean;
  isLoadingDataExcel?: boolean;
  setIsOldSheetOrAreaSelected?: Dispatch<SetStateAction<boolean>>;
  setIsSheetChartAndAreaToHide?: Dispatch<SetStateAction<boolean>>;
  isSheetChartAndAreaToHide?: boolean;
}

export const DropDownAreaAndChart = (input: DropDownAreaAndChartProps) => {
  const { type, areasItems, isFileExcelExisting, isComponentInstance, isLocked } = useDropDownAreaAndChart(input);
  function getSelectedArea(): string {
    if (input?.name?.name?.includes("!")) {
      return input?.name?.name?.split("!")[1];
    }
    return input?.name?.name;
  }

  function getAreaWithCurrentSheet() {
    return areasItems.find((value) => value?.key?.toString()?.split("!")[0] === input?.name?.name?.split("!")[0]);
  }

  function isHidden(): boolean {
    let iComboBoxOption = getAreaWithCurrentSheet();
    let toHide =
      (areasItems.find((value) => value?.key === input?.name?.name) && input.isOldValueForAreaToHide) ||
      !input?.name?.name ||
      input.isSheetChartAndAreaToHide ||
      iComboBoxOption !== undefined;
    if (toHide) {
      input.setIsOldSheetOrAreaSelected(false);
    } else {
      input.setIsOldSheetOrAreaSelected(true);
    }
    return toHide;
  }

  function getSelectedKey() {
    if (input.isSheetChartAndAreaToHide) {
      return null;
    }
    return input?.name?.name ?? null;
  }

  return (
    <>
      <Dropdown
        id="area_or_chart_dropdown"
        label={formatMessage(`cof.createnewobject.${type}`)}
        options={input.isLoadingDataExcel ? [] : areasItems}
        onRenderCaretDown={input.onRenderAreaCaretDown}
        placeholder={
          input.isLoadingDataExcel
            ? formatMessage("cof.base.loadingdata")
            : formatMessage(
                areasItems == null || (areasItems.length == 0 && input.sheet)
                  ? `cof.createnewobject.${type}.noavailable`
                  : "cof.base.select"
              )
        }
        onChange={(_event, option) => input.selectNameComboBox(option)}
        selectedKey={getSelectedKey()}
        responsiveMode={ResponsiveMode.large}
        disabled={
          input.sheet == null ||
          !isFileExcelExisting ||
          isComponentInstance ||
          isLocked ||
          (input.isEdit &&
            ((input.hasSheetToBeSelected && input.sheet?.code === input.sheet?.desc) ||
              input.isSheetChartAndAreaToHide))
        }
        required
      />
      {input.objectSource === "EXCEL" && input.isEdit && !input.isLoadingDataExcel && (
        <span style={{ color: "red" }} hidden={isHidden()}>
          {formatMessage("cof.base.oldvalue")} {getSelectedArea()}
        </span>
      )}
    </>
  );
};
